import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {UserService} from "./user.service";
import {PopupService} from "./popup.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Store} from "@ngrx/store";
import {AuthService} from "./auth.service";
@Injectable({
  providedIn: 'root'
})
export class NoteService {

  private apiUrl = environment.api.url;

  token: string;
  constructor(
    private store: Store,
    private http: HttpClient,
    private authService: AuthService,
  ) { }

  showNotes(search_id, ){

    const url = `${this.apiUrl}/note/show?search_id=` + search_id + `&page=` + 1;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.get<any>(url, httpOptions)

  }

  // newNote(id,data,search_id = undefined){
  //   return this.apiService.doRequest('api/notes/', 'POST', search_id ? {user_id:id,content:data,search_id:search_id} : {user_id:id,content:data});
  // }

  createNote(user_id,search_id,content) {

    const url = `${this.apiUrl}/note/create`;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.post<any>(url, {"note_content" : content, "user_id" : user_id, "search_id":search_id} ,httpOptions)
  }


  getNotesSummary(search_id,user_id) {

    const url = `${this.apiUrl}/note/summary`;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

   console.log("User id in triggering notes summary",user_id);
    return this.http.post<any>(url, { "search_id":search_id, "user_id":user_id} ,httpOptions)
  }
  deleteNote(note_id,search_id) {

    const url = `${this.apiUrl}/note/delete`;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.post<any>(url, {"note_id":note_id, "search_id":search_id} ,httpOptions)
  }

  showMoreNotes(search_id,page) {

    const url = `${this.apiUrl}/note/show?search_id=` + search_id + `&page=` + page ;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.get<any>(url, httpOptions)

  }

  editNote(note,edited_note_text){
    const url = `${this.apiUrl}/note/edit`;

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': 'en',
        'Authorization': `Bearer ${this.token}` // Use the token here
      })
    };

    return this.http.post<any>(url, {"note":note,"edited_note_text":edited_note_text} ,httpOptions)
  }

}
